/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespCollectionsModuleOld_componentModule = {
    readonly title: string | null;
    readonly items: ReadonlyArray<{
        readonly cmsId: number | null;
        readonly title: string | null;
        readonly imageUrl: string | null;
        readonly linkData: {
            readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
        };
    } | null> | null;
    readonly " $refType": "HpRespCollectionsModuleOld_componentModule";
};
export type HpRespCollectionsModuleOld_componentModule$data = HpRespCollectionsModuleOld_componentModule;
export type HpRespCollectionsModuleOld_componentModule$key = {
    readonly " $data"?: HpRespCollectionsModuleOld_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespCollectionsModuleOld_componentModule">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "HpRespCollectionsModuleOld_componentModule",
  "type": "CollectionsModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "Product",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cmsId",
          "args": null,
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageUrl",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "linkData",
          "storageKey": null,
          "args": null,
          "concreteType": "LinkData",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '2dc6a8e446bba831a392b456331ea2d4';
export default node;
